<template>
  <el-dialog
    :title="`Change ${role === 'member' ? 'Team Member' : 'Customer'} Email`"
    :visible.sync="shouldShow"
    @close="closeEvent"
    append-to-body
    width="30%"
  >
    <el-form :model="form" label-position="top" ref="form">
      <el-row>
        <el-col :span="24">
          <el-form-item label="" prop="current_email" :rules="validateEmail()">
            <el-input
              v-model="form.current_email"
              type="text"
              placeholder="Current email"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="" prop="new_email" :rules="validateEmail()">
            <el-input
              v-model="form.new_email"
              type="text"
              placeholder="New email"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button plain @click="shouldShow = false">Cancel</el-button>
      <el-button
        type="primary"
        :loading="changing"
        :disabled="disableChange"
        @click="changeEmail"
        >Change</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import customer from "@/requests/customers/customer/actions";

export default {
  name: "CustomerEmailChange",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    customer: {
      type: Object,
      default() {
        return {};
      },
    },
    email: {
      type: String,
      default: "",
    },
    role: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      form: {
        current_email: "",
        new_email: "",
      },
      changing: false,
    };
  },
  computed: {
    shouldShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
    disableChange() {
      return (
        this.form.new_email && this.form.current_email === this.form.new_email
      );
    },
    location() {
      return this.$store.getters.location;
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.form.current_email = this.role ? this.email : this.customer.email;
      }
    },
  },
  methods: {
    closeEvent() {
      this.shouldShow = false;
      this.$refs.form.resetFields();
    },
    changeEmail() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return false;
        }

        this.changing = true;
        customer
          .email(this.form)
          .then((response) => {
            if (response.data.status) {
              this.$message.success(response.data.message);
              this.changing = false;
              this.$emit("success", { email: this.form.new_email });
              this.closeEvent();
            } else {
              this.changing = false;
              this.$message.error(response.data.message);
            }
          })
          .catch((error) => {
            this.changing = false;
            this.$message.error(error.response.data.message);
          });
        return true;
      });
    },
  },
};
</script>

<style lang="scss"></style>
